import React from 'react';
import styled from 'styled-components';
import FlatButton from '../input/FlatButton';
import Spacer from '../Spacer';
import { LightParagraph, PageTitle } from '../typography/Typography';

const Container = styled.div`
  display: flex;
  align-items: flex-start;
`;

const Image = styled.img`
  width: 86px;
  height: 86px;
  border-radius: 18%;
  box-shadow: 0px 3px 9px #00000014;
`;

const Content = styled.div`
  flex: 1;
`;

type Props = {
  title: string;
  imageURL?: string;
  description?: string;
  className?: string;
  onUpdate?: () => void;
};

export function ApiHeader({
  title,
  imageURL,
  description,
  className,
  onUpdate,
}: Props) {
  return (
    <Container className={className}>
      <Image src={imageURL} />
      <Spacer horizontal spacing={3} />
      <Content>
        <PageTitle>{title}</PageTitle>
        <Spacer vertical spacing={1} />
        <LightParagraph>{description}</LightParagraph>
      </Content>
      {onUpdate && (
        <FlatButton darkenOnHover color='#5C6EF8' onClick={onUpdate}>
          Update details
        </FlatButton>
      )}
    </Container>
  );
}
